import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('auth', [
            'isLoggedIn',
            'currentUserAccount',
        ]),
    },

    methods: {
        currentAccountIsSameAs(account) {
            const { isLoggedIn, currentUserAccount } = this;

            return isLoggedIn ? currentUserAccount.id === account.id : false;
        },
    },
};



// WEBPACK FOOTER //
// ./src/global/mixins/AccountMixin.js